import axios from './axios';

export const getInvoices = ({ params } = {}) => axios.get(`invoices`, { params });
export const getInvoice = ({id, params }) => axios.get(`invoices/${id}`, { params });
export const createInvoice = ({ data }) => axios.post('invoices', data);
export const updateInvoice = ({ id, data }) => axios.put(`invoices/${id}`, data);
export const deleteInvoice = ({ id }) => axios.delete(`invoices/${id}`);
export const emailInvoice = ({ id, data }) => axios.post(`invoices/${id}/send_email`, data);
export const getInvoiceTotals = ({ params } = {}) => axios.get(`invoices/totals`, { params });
